// ErrorHandling.js

let showErrorModalFunction;

export const initializeErrorHandling = (showErrorModal) => {
  showErrorModalFunction = showErrorModal;
};

export const showErrorModal = (message) => {
  if (showErrorModalFunction) {
    showErrorModalFunction(message);
  } else {
    console.error('Error handling not initialized');
  }
};
